import { Component, inject, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TableConfiguration } from "../../../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { ActivatedRoute } from "@angular/router";
import { GET_SENSOR_STATUS } from "../../../../../store/entities/warehouse-management/device/device.graphql";
import { GET_SENSOR_LIVE_STATUS } from "../../../../../store/entities/warehouse-management/device/device.graphql";
import { GraphqlService } from "../../../../../services/graphql.service";
import {
  faBattery4,
  faCircle,
  faCircleInfo,
  faDroplet,
  faHeartPulse,
  faSignal,
  faStopwatch,
  faTemperature2,
  faThermometer,
} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-sensor-status-modal",
  templateUrl: "./sensor-status-modal.component.html",
  styleUrl: "./sensor-status-modal.component.scss",
})
export class SensorStatusModalComponent implements OnInit {
  private dialogRef: MatDialogRef<SensorStatusModalComponent> = inject(
    MatDialogRef<SensorStatusModalComponent>
  );
  private route: ActivatedRoute = inject(ActivatedRoute);
  private apollo: GraphqlService = inject(GraphqlService);

  protected readonly faCircleInfo = faCircleInfo;
  protected readonly faStopwatch = faStopwatch;
  protected readonly faCircle = faCircle;
  public tableData;
  title: string;
  loading: boolean = false;
  refreshDataTable: boolean = false;
  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "serial_number", label: "Serial Number" },
      { name: "status", label: "Status" },
      { name: "TIMESTAMP", label: "Time Stamp" },
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  async ngOnInit() {
    this.title = "Sensor Status";
    await this.fetchSensorStatus();
  }

  async fetchSensorStatus() {
    const query = GET_SENSOR_LIVE_STATUS;
    const response: any = await this.apollo.query({
      query,
      variables: {
        filtering: {
          warehouse: this.route.snapshot.queryParams["id"],
        },
      },
    });
    const getSensorsStatus =
      response?.data?.getSensorsWithLiveStatus?.data?.dashboardData;
    if (getSensorsStatus) {
      try {
        this.tableData = JSON.parse(getSensorsStatus);
      } catch (error) {
        console.error("Error Parsing Sensor Status:", error);
      }
    } else {
      console.error("Not available");
    }
  }
  closeModal() {
    this.dialogRef.close();
  }
}
